import { render, staticRenderFns } from "./local-time.vue?vue&type=template&id=a1f34012&scoped=true"
import script from "./local-time.vue?vue&type=script&lang=js"
export * from "./local-time.vue?vue&type=script&lang=js"
import style0 from "./local-time.vue?vue&type=style&index=0&id=a1f34012&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f34012",
  null
  
)

export default component.exports